<div *ngIf="loadError || actionError" class="alert alert-danger m-3" role="alert">
  {{ loadError || actionError }}
</div>
<ngx-extended-pdf-viewer
  *ngIf="src"
  [height]="'90vh'"
  [src]="src"
  [customToolbar]="additionalButtons"
  [showToolbar]="showToolbar"
  [showBookmarkButton]="false"
  [showSidebarButton]="true"
  [textLayer]="true"
  [showHandToolButton]="true"
  [showFindButton]="true"
  [showPagingButtons]="true"
  [showZoomButtons]="true"
  [showPresentationModeButton]="true"
  [showOpenFileButton]="false"
  [showPrintButton]="true"
  [showDownloadButton]="false"
  [showSecondaryToolbarButton]="true"
  [showRotateButton]="true"
  [showHandToolButton]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="false"
  [textLayer]="true"
  [delayFirstView]="100"
  [useInlineScripts]="false"
  [showDrawEditor]="false"
  [showStampEditor]="false"
  zoom="page-fit"
  (pdfLoaded)="onPdfLoaded($event)"
  (pdfLoadingFailed)="onPdfLoadingFailed($event)"
  (pageRendered)="onPageRendered($event)"
  (afterPrint)="onAfterPrint()">
</ngx-extended-pdf-viewer>

<ng-template #additionalButtons>
  <div id="toolbarViewer">
    <div id="toolbarViewerLeft">
      <pdf-toggle-sidebar></pdf-toggle-sidebar>
      <div class="toolbarButtonSpacer"></div>
      <pdf-find-button></pdf-find-button>
      <pdf-paging-area></pdf-paging-area>
    </div>
    <pdf-zoom-toolbar></pdf-zoom-toolbar>
    <div id="toolbarViewerRight">
      <pdf-presentation-mode></pdf-presentation-mode>
      <pdf-print></pdf-print>
      <button title="Enviar via Whatsapp"
        *ngIf="['whatsapp', 'send_file'] | permission | async"
        (click)="sendToWA()"
        [disabled]="!config?.src || !canSendToWA"
        style="height: 22px; width: 22px; margin: 0; position: relative; float: left; padding: 8px 6px 0; border: none; background: none;">
        <i class="fab fa-whatsapp"></i>
      </button>
      <button title="Download"
        (click)="onDownloadClick()"
        class="toolbarButton"
        style="height: 22px; width: 22px; margin: 0; position: relative; float: left; padding: 7px 6px 0; border: none; background: none;">
        <i class="fas fa-download"></i>
      </button>
      <div class="verticalToolbarSeparator hiddenSmallView"></div>
      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
      <button title="Fechar"
        (click)="hide()"
        style="height: 22px; width: 22px; margin: 0; position: relative; float: left; padding: 7px 6px 0; border: none; background: none;">
        <i class="far fa-times-circle"></i>
      </button>
    </div>
  </div>
</ng-template>
